module.exports = __webpack_public_path__ + "img/pd-img-body10.68516f73.png";